// extracted by mini-css-extract-plugin
export default {"testLabel":"testLabel__52V4V","slidedown":"slidedown__wLZ8o","barberpole":"barberpole__8wfLQ","bgchange":"bgchange__KEQf1","logo":"logo__GZvSi"};